// Último id de requisição por componente e chave (WeakMap: some junto com o componente)
const lastRequestIds = new WeakMap();

// Só a requisição mais recente de cada componente/chave entrega a resposta: com o filtro reativo das tabelas,
// várias buscas ficam em andamento ao mesmo tempo e uma resposta antiga que chegasse depois sobrescreveria a lista.
// A promise de uma requisição substituída nunca resolve nem rejeita, então o then/catch de quem chamou não roda
export function onlyLatestRequest(owner, key, promise) {
    const ids = lastRequestIds.get(owner) || {};
    const requestId = (ids[key] || 0) + 1;
    ids[key] = requestId;
    lastRequestIds.set(owner, ids);
    const isCurrentRequest = () => lastRequestIds.get(owner)[key] === requestId;

    return new Promise((resolve, reject) => {
        promise
            .then(response => {
                if (isCurrentRequest()) resolve(response);
            })
            .catch(error => {
                if (isCurrentRequest()) reject(error);
            });
    });
}
